import { calculateVotingEndDate } from "./calculate-voting-end-date";

export interface IReactionTimeWindowOpenParams {
    creationDate: Date;
}

export function isReactionTimeWindowOpen({ creationDate }: IReactionTimeWindowOpenParams): boolean {
    const votingEndDate = calculateVotingEndDate(creationDate);
    return !(new Date() <= votingEndDate);
}
